"use client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetch } from "libs";
import { DELETE_ADMIN_MODEL } from "api"; // Import your API endpoint for admin delete

export const useDeleteAdminModel = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      model_id,
      model_username,
    }: {
      model_id: string;
      model_username: string;
    }) => {
      const response = await fetch(DELETE_ADMIN_MODEL, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ model_id, model_username }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || "Error deleting the model");
      }

      return response.json();
    },
    onSuccess: () => {
      // Optionally invalidate or refetch queries here
      queryClient.invalidateQueries({ queryKey: ["models"] });
      console.log("Admin model deletion successful");
    },
    onError: (error) => {
      console.error("Error in useDeleteAdminModel:", error);
    },
  });
};

export default useDeleteAdminModel;
